import Modal from 'react-responsive-modal';
import { useMemo } from 'react';
import iconFacebook from '../../../assets/images/facebook.png';
import iconTelegram from '../../../assets/images/telegram.png';
import iconTwitter from '../../../assets/images/twitter.png';
import iconWhatsapp from '../../../assets/images/whatsapp.png';
import { Notify } from '../../../components/Notify';
import { ILandingBusiness } from '../../../interfaces/ILandingBusiness';
import { IClient } from '../../../interfaces/IClient';

interface IShareModal {
  landingBusiness: ILandingBusiness;
  playerId: string;
  client: IClient;
  modalIsOpen: boolean;
  toggleModal: () => void;
}

export function ShareModal({
  landingBusiness,
  playerId,
  client,
  modalIsOpen,
  toggleModal,
}: IShareModal) {
  const shareUrl = useMemo(() => {
    if (landingBusiness) {
      const baseUrl =
        window.location.hostname === 'oqpwahom.web.app' ||
        window.location.hostname === 'oqpwahom.firebaseapp.com'
          ? 'https://oqpwahom.web.app'
          : 'https://app.oqdigital.com';

      return `${baseUrl}/landingBusiness/${playerId}/${landingBusiness.id}`;
    } else return '';
  }, [playerId, landingBusiness]);

  const message = useMemo(() => {
    return `${' ' + '-' + ' ' + client?.companyName + 'tem um convite para você.'}`;
  }, [client]);

  const fbShare = async () => {
    window.open(
      `https://facebook.com/sharer/sharer.php?u=${shareUrl}&quote=${message}`,
      'pop',
      'width=600, height=400, scrollbars=no'
    );
  };

  const whatsappShare = async () => {
    window.open(
      `https://api.whatsapp.com/send?text=${message} - ${shareUrl}`,
      '_blank'
    );
  };

  const twitterShare = async () => {
    window.open(
      `https://twitter.com/share?text=${encodeURIComponent(message)}&url=${shareUrl}`,
      'pop',
      'width=600, height=400, scrollbars=no'
    );
  };

  const telegramShare = async () => {
    window.open(
      `https://telegram.me/share/url?url=${encodeURIComponent(
        shareUrl
      )}&text=${message}`,
      '_blank',
      'width=600, height=400, scrollbars=no'
    );
  };

  return (
    <Modal open={modalIsOpen} onClose={toggleModal} center>
      <div
        style={{
          position: 'relative',
          transition: '0.25s',
          background: '#fff',
          zIndex: 1,
          borderTopRightRadius: '10px',
          borderTopLeftRadius: '10px',
          margin: '20px',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderBottom: `1px solid #00000030`,
            marginBottom: '20px',
          }}
        >
          <span
            style={{
              fontSize: '18px',
              fontWeight: '500',
              color: `${client?.primaryColor}`,
            }}
          >
            Divulgar
          </span>
          <button
            onClick={toggleModal}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '40px',
              height: '40px',
              outline: 'none',
              border: 'none',
              backgroundColor: 'transparent',
            }}
          >
            <i className="material-icons-outlined">close</i>
          </button>
        </div>
        <div>
          <span>Divulgue rapidamente via</span>
          <div style={{ display: 'flex', gap: '40px' }}>
            <button
              onClick={fbShare}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: `1px solid #00000030`,
                outline: 'none',
                backgroundColor: 'transparent',
                aspectRatio: '1/1',
                width: '100%',
                borderRadius: '100%',
              }}
            >
              <img
                src={iconFacebook}
                alt={iconFacebook}
                style={{ width: '45%' }}
              />
            </button>
            <button
              onClick={twitterShare}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: `1px solid #00000030`,
                outline: 'none',
                backgroundColor: 'transparent',
                aspectRatio: '1/1',
                width: '100%',
                borderRadius: '100%',
              }}
            >
              <img
                src={iconTwitter}
                alt={iconTwitter}
                style={{ width: '45%' }}
              />
            </button>
            <button
              onClick={whatsappShare}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: `1px solid #00000030`,
                outline: 'none',
                backgroundColor: 'transparent',
                aspectRatio: '1/1',
                width: '100%',
                borderRadius: '100%',
              }}
            >
              <img
                src={iconWhatsapp}
                alt={iconWhatsapp}
                style={{ width: '45%' }}
              />
            </button>
            <button
              onClick={telegramShare}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: `1px solid #00000030`,
                outline: 'none',
                backgroundColor: 'transparent',
                aspectRatio: '1/1',
                width: '100%',
                borderRadius: '100%',
              }}
            >
              <img
                src={iconTelegram}
                alt={iconTelegram}
                style={{ width: '45%' }}
              />
            </button>
          </div>
          <span>Ou copie o link</span>
          <div className="mt-3">
            <div
              style={{
                display: 'flex',
                borderRadius: '30px',
                width: '100%',
                border: `1px solid #00000030`,
                overflow: 'hidden',
              }}
            >
              <input
                className="px-4"
                placeholder="Link encurtado"
                value={shareUrl}
                disabled
                type="text"
                style={{
                  outline: 'none',
                  border: 'none',
                  width: '100%',
                  textAlign: 'center',
                  fontSize: '16px',
                }}
              />
              <button
                onClick={() => {
                  navigator.clipboard.writeText(shareUrl);
                  Notify('Texto copiado com sucesso', 'success');
                }}
                className="p-4"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'white',
                  outline: 'none',
                  border: 'none',
                  width: '40px',
                  height: '40px',
                  borderRadius: '100%',
                  backgroundColor: '#00000020',
                }}
              >
                <i className="material-icons-outlined">content_copy</i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
